<template>
  <div
    v-bind="attributes"
    class="NewsroomCard flex h-full flex-col rounded-card border border-solid border-line bg-surface p-6 text-center shadow-sm"
    data-testid="NewsroomCard"
  >
    <div class="flex justify-center">
      <router-link
        v-if="newsroom.id"
        :to="{ name: 'newsroom.stories', params: { newsroomSlug: newsroom.slug } }"
        itemprop="logo"
        itemscope=""
        itemtype="https://schema.org/ImageObject"
      >
        <round-avatar
          :src="newsroom.logo.cropped"
          :alt="newsroom.name"
          :acronym-fallback="newsroom.name"
          :main-color="newsroom.main_color"
          size="xx-large"
        />
        <meta :content="newsroom.logo.cropped" itemprop="url">
      </router-link>
    </div>

    <h4 itemprop="name" class="mt-4 font-display text-lg font-bold text-ink">
      {{ newsroom.name }}
    </h4>

    <website-link
      v-if="newsroom.website"
      :href="newsroom.website"
      class="mt-1 block break-words text-sm text-muted-soft hover:text-accent"
      itemprop="sameAs"
    />

    <div
      v-if="newsroom.description"
      :title="newsroom.description"
      itemprop="description"
      class="mt-3 break-words text-base leading-relaxed text-muted"
    >
      {{ truncate(newsroom.description, truncateDescription) }}
    </div>

    <div
      v-if="country"
      class="mt-3 flex items-center justify-center gap-1.5 text-sm font-semibold text-muted"
    >
      <country-flag v-if="country.iso_alpha2" :country="country.iso_alpha2" />
      <span>{{ country.name }}</span>
    </div>

    <div class="mt-auto flex flex-wrap items-center justify-center gap-2 pt-6">
      <router-link
        v-if="!$isEmpty(newsroom)"
        :to="{ name: 'newsroom.stories', params: { newsroomSlug: newsroom.slug } }"
        data-testid="newsroomLink"
        class="inline-flex cursor-pointer rounded-full border border-solid border-outline bg-white px-5 py-2 text-sm font-bold text-ink transition-colors hover:border-ink"
      >
        {{ $t('pages.dashboard.newsroom') }}
      </router-link>

      <follow-newsroom-button :newsroom="newsroom" />
    </div>
  </div>
</template>

<script>
import TruncateMixin from '@/shared/js/mixins/TruncateMixin'

export default {
  mixins: [TruncateMixin],

  props: {
    newsroom: {
      type: Object,
      required: true
    },
    authorSchema: {
      type: Boolean,
      default: false
    },
    truncateDescription: {
      type: Number,
      default: 250
    }
  },

  computed: {
    attributes () {
      const attrs = {
        itemscope: true,
        itemtype: 'https://schema.org/Organization'
      }
      if (this.authorSchema) attrs.itemprop = 'author'
      return attrs
    },
    /**
     * Returns the first newsroom country
     * @return {HF_Country}
     */
    country () {
      return this.$safeGet(this.newsroom, 'country.data')
    }
  }
}
</script>
